const Header = (props) => {
    return (
        <nav className="w-full py-3 px-4 bg-green-200 shadow-md flex flex-row items-center text-black font-bold">
            
            <div onClick={props.showInitialScreen} className="bg-white rounded-full p-1 w-16 border-black border-2 mr-3 cursor-pointer">
                <img src={require('../assets/images/brand.png')} alt="Logo" width="80px"></img>
            </div>

            <span className="hidden sm:block text-2xl mr-auto">Noor Homeo Clinic</span>
            <span className="inline sm:hidden text-2xl mr-auto">NHC</span>

            { props.currentScreen!=='appointment' && <button onClick={props.showAppointmentScreen} type="button" className="ml-3 rounded-md border border-gray-300 bg-black py-3 px-3 font-medium leading-4 text-white shadow-sm hover:bg-gray-800">Make an Appointment</button> }

        </nav>
    );
}

export default Header;
